export const openWeatherAPIKEY = '7e8a12d32df83bd0eb453b012c80902c';
export const unsplashAPIKEY = 'NH330OqyEiMI9pf0np8gFOARxiRwztw29vsSqzER9Go';